import { Button } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";
import { route } from "../../../../../router/route";
import { useNavigate } from "react-router-dom";

const RecruitInfoSidebar = ({
  careerLevel,
  positionType,
  deadline,
  location,
  salary,
  id,
  title,
}) => {
  const navigate = useNavigate();
  return (
    <div className="border border-semantic-secondary-foreground-strong-default rounded-md p-[24px] mb-[16px]">
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="xlg"
          textData={{
            caption: "경력사항",
          }}
        />
        <TextDisplay
          size="lg"
          textData={{
            description: careerLevel,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="xlg"
          textData={{
            caption: "채용 유형",
          }}
        />
        <TextDisplay
          size="lg"
          textData={{
            description: positionType,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="xlg"
          textData={{
            caption: "마감일",
          }}
        />
        <TextDisplay
          size="lg"
          textData={{
            description: deadline,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="xlg"
          textData={{
            caption: "근무지",
          }}
        />
        <TextDisplay
          size="lg"
          textData={{
            description: location,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="xlg"
          textData={{
            caption: "예상연봉",
          }}
        />
        <TextDisplay
          size="lg"
          textData={{
            description: salary,
          }}
        />
      </div>
      <div className="mt-[24px]">
        <Button
          size="xlg"
          variant="filled"
          state="primary"
          className="w-full h-[36px] cursor-none custom-cursor"
          onClick={() => navigate(`${route.apply}/${id}?title=${title}`)}
        >
          지원하기
        </Button>
      </div>
    </div>
  );
};

export { RecruitInfoSidebar };
